export default "__VITE_ASSET__3d54623f__"